<template>
  <fragment v-if="campaign">
    <div class="channel-edit-group channel-edit-group-fields">
      <div class="field-w">
        <b-field>
          <b-dropdown v-model="selectedPhone" scrollable aria-role="list"
                @active-change="onDropdownActiveChange" @change="onSelectedPhoneChange($event)">
            <template #trigger>
              <b-button>
                <span class="dropdown-trigger-value">{{ selectedPhone ? selectedPhone.Phone : $t("CampaignEdit.WhatsappPhones.SelectPhone") }}</span>
                <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
              </b-button>
            </template>
            <b-dropdown-item custom aria-role="listitem" class="filter-search">
              <b-input v-model="phoneSearch" class="search" :placeholder="$t('Search')" expanded />
            </b-dropdown-item>
            <b-dropdown-item v-for="whatsappPhone in whatsappPhonesFiltered" :key="whatsappPhone.Id" :value="whatsappPhone" aria-role="listitem"
                  :disabled="whatsappPhone.IsSelected">
              <span class="text">{{ whatsappPhone.Phone }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </b-field>
      </div>
    </div>
  </fragment>
</template>

<script lang="ts">
import Fragment from "vue-fragment";
import { Component, Vue, Watch } from "vue-property-decorator";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/he";
import { Getter } from "vuex-class";
import { Campaign, CampaignEditViewModel } from "@/models/campaigns/Campaign";
import { CampaignEditPageKind } from "@/models/campaigns/CampaignEditPageKind";
import { CampaignEditWhatsappPhonesData } from "@/models/campaigns/CampaignEditWhatsappPhonesData";
import HelperService from "@/services/HelperService";
import CampaignsApiService from "@/services/api/CampaignsApiService";
import IconBase from "../IconBase.vue";
import IconCaretDown from "../icons/IconCaretDown.vue";
import { WhatsappPhone } from "@/models/WhatsappPhone";

Vue.use(Fragment.Plugin);
const namespace = "campaignsModule";

@Component({
  components: {
    IconBase,
    IconCaretDown,
  },
})
export default class TabWhatsappPhones extends Vue {

  //#region Vuex getters and actions

  @Getter("campaignEditViewModel", { namespace }) campaignEditViewModel!: CampaignEditViewModel;

  //#endregion Vuex getters and actions


  //#region Properties

  phoneSearch = "";
  campaignEditWhatsappPhonesData?: CampaignEditWhatsappPhonesData = {
    WhatsAppPhones: [],
  };
  selectedPhone: WhatsappPhone | null = null;

  CampaignEditPageKind = CampaignEditPageKind;

  //#endregion Properties


  //#region Watchers

  @Watch("campaignEditViewModel", { immediate: true })
  onCampaignEditViewModelChange(newCampaignEditViewModel: CampaignEditViewModel, oldCampaignEditViewModel: CampaignEditViewModel): void {
    if (!newCampaignEditViewModel) {
      return;
    }
    let loader = this.$loading.show();
    CampaignsApiService.getCampaignEditWhatsappPhonesData(this.campaign.Id).then((data: CampaignEditWhatsappPhonesData) => {
      this.campaignEditWhatsappPhonesData = data;
      if (this.campaign.WhatsAppPhoneId) {
        const phone = this.campaignEditWhatsappPhonesData.WhatsAppPhones.find((phone: WhatsappPhone) => phone.Id === this.campaign.WhatsAppPhoneId);
        if (phone) {
          this.selectedPhone = phone;
        }
      }
    }).finally(() => {
      loader.hide();
    });
  }

  //#endregion Watchers


  //#region Getters

  get campaign(): Campaign {
    return this.campaignEditViewModel?.Campaign;
  }

  get whatsappPhonesFiltered(): WhatsappPhone[] {
    if (this.campaignEditWhatsappPhonesData) {
      return this.campaignEditWhatsappPhonesData.WhatsAppPhones.filter((i: WhatsappPhone) => i.Phone.toLowerCase().indexOf(this.phoneSearch.toLowerCase()) >= 0);
    }
    return [];
  }

  //#endregion Getters


  //#region Handlers

  onDropdownActiveChange(show: boolean) {
    HelperService.onDropdownActiveChange(show);
  }

  onSelectedPhoneChange(phone: WhatsappPhone): void {
    this.campaign.WhatsAppPhoneId = phone.Id;
  }

  //#endregion Handlers
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.channel-edit-group {
  margin-bottom: 25px;

  &.channel-edit-group-field {
    max-width: 894px;

    .channel-edit-field {
      margin-bottom: 1rem;
    }

    .label {
      font-size: 17px;
      margin: 0;
      display: inline;
    }
  }

  &.channel-edit-group-fields {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -12px;

    .field-w {
      padding: 0 12px 25px;
      flex-grow: 1;
      width: 50%;

      .dropdown {
        width: 100%;

        .dropdown-item-with-icon {
          display: flex;

          .icon-w {
            display: flex;
            margin-inline-end: 0.5rem;
            min-width: 22px;

            img {
              max-height: 22px;
              min-width: 22px;
              width: 22px;
            }
          }
        }

        .dropdown-trigger {

          .button {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
